
const orderInfo = {
    state: {
        address: null,
        token: null
    },
    mutations: {
        setAddress(state, address) {
            state.address = address;
        },
        setToken(state, token) {
            state.token = token;
        }
    },
    actions: {
        async changeOrderAddress({commit, state}, address) {
            try {
                const { data } = await axios.post(`/api/order-info/${state.token}/change-address`, {
                    address: address.token
                });
                commit('setAddress', data.data.address);
            } catch (errors) {
                console.log(errors)
            }
        }
    }
}

export default orderInfo;
